import { useEffect } from 'react';

/**
 * Hook для автоматической прокрутки к заголовку и установки фокуса на указанное поле ввода
 * @param fieldName - имя поля для фокуса
 */
export function useScrollAndFocusField(fieldName: string) {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const titleElement = document.getElementById('logo-page');
      if (titleElement) {
        titleElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      const inputElement = document.querySelector(`[name="${fieldName}"]`) as HTMLElement;
      if (inputElement) {
        setTimeout(() => {
          inputElement.focus();
        }, 1000);
      }
    }, 100);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [fieldName]);
}
